import api from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
class SpaceService {
  // 创建项目
  postAddPrj (params) {
    return api.post(`${backendUrl}/projects`, params)
  }
  // 获取项目模板数据
  getPrjPattern (params) {
    return api.get(`${backendUrl}/projects/prjPattern`, params)
  }
  // 获取我参与的项目列表
  getPrjList (params) {
    return api.get(`${backendUrl}/projects`, params)
  }
  // 获取全部项目列表
  getAllPrjList (params) {
    return api.get(`${backendUrl}/projects/all`, params)
  }
  // 获取项目详细数据
  getPrjDetail (params) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.get(`${backendUrl}/projects/recorded/${params.id}`, params)
    }
    return api.get(`${backendUrl}/projects/${params.id}`, params)
  }
  // 搜索我参与的
  getSearchJoinedPrjs (params) {
    return api.get(`${backendUrl}/projects/search`, params)
  }
  // 搜索全部
  getSearchAllPrjs (params) {
    return api.get(`${backendUrl}/projects/all/search`, params)
  }
  // 重命名
  renamePrj (params) {
    return api.put(`${backendUrl}/projects/${params.projectId}/rename`, params, headers)
  }
  // 查询成员列表
  getMembers (params) {
    return api.get(`${backendUrl}/projects/${params.id}/members`, params)
  }
  // 查询项目角色
  getRole (params) {
    return api.get(`${backendUrl}/projects/${params.id}/roleType`, params, headers)
  }
  // 更改项目进度
  statusHandle (params) {
    return api.patch(`${backendUrl}/projects/${params.id}/status`, params, headers)
  }
  // 更改项目负责人
  changeAuthor (params) {
    return api.put(`${backendUrl}/projects/${params.id}/manager`, params, headers)
  }
  // 添加成员
  addMembers (params, id, url) {
    return api.postArr(`${backendUrl}/projects/${id}/member?url=${url}`, params)
  }
  // 删除成员
  removeMembers (id, memberId, url) {
    return api.delete(`${backendUrl}/projects/${id}/members/${memberId}?url=${url}`, {}, headers)
  }
  // 获取项目文件夹权限人员列表
  getPrivilegeMembers (id, params) {
    return api.get(`${backendUrl}/projects/${id}/file/privilege`, params, headers)
  }
  // 文件夹授权
  postFilePrivilege (id, query, params) {
    return api.postArr(`${backendUrl}/projects/${id}/file/black_white_list?` + queryString.stringify(query), params)
  }
  // 获取当前用户对文件夹的权限
  getFilePrivilege (params) {
    return api.get(`${backendUrl}/projects/file/privilege`, params, headers)
  }
  // 获取带权限的子文件夹
  getFolderPrivilegeList (query) {
    return api.post(`${backendUrl}/projects/file/permission_list?` + queryString.stringify(query), {}, headers)
  }
  // 备案
  putCopyRight (id, query) {
    return api.put(`${backendUrl}/projects/${id}/record?` + queryString.stringify(query), {}, headers)
  }
  // 备案列表
  getRecordedList (params) {
    return api.get(`${backendUrl}/projects/recorded`, params, headers)
  }
  // 备案列表-搜索
  getSearchRecordedList (params) {
    return api.get(`${backendUrl}/projects/recorded/search`, params, headers)
  }

  // 备案成员列表
  getRecordedMembersList (path) {
    return api.get(`${backendUrl}/projects/recorded/${path.id}/members`, {}, headers)
  }

  // 设置备案成员权限
  setRecordedMembersPrivilege (params, path) {
    return api.putArr(`${backendUrl}/projects/recorded/${path.id}/members`, params)
  }

  // 获取gccstoken
  getGCCSToken () {
    return api.get(`${backendUrl}/session`)
  }

  // 创建备案项目
  getRecordedCode () {
    return api.get(`${backendUrl}/projects/recorded/code`)
  }

  // 创建备案项目
  createRecorded (params) {
    return api.post(`${backendUrl}/projects/recorded`, params)
  }

  // 单文件成功通知
  singleFileNotice (params) {
    return api.post(`${backendUrl}/projects/recorded/upload/single`, params, headers)
  }

  // 备案项目上传结果通知
  uploadResultNotice (params) {
    return api.post(`${backendUrl}/projects/recorded/upload/result`, params, headers)
  }

  // 获取备案项目的上传外链地址
  getRecordedUploadUrl () {
    return api.get(`${backendUrl}/projects/recorded/upload/url`)
  }

  // 更新备案项目状态为上传中
  updateProjectStatus (params) {
    return api.post(`${backendUrl}/projects/recorded/reupload`, params, headers)
  }

}
export default new SpaceService()
